import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  height: auto;

  .ag-theme-balham {
    width: 100%;
    height: 100%;
    font-family: 'Roboto';

    .ag-root,
    .ag-side-bar,
    .ag-root-wrapper,
    .ag-status-bar {
      border: none;
    }

    .ag-root-wrapper {
      border-bottom: 1px solid ${colors.grey3};
    }

    .ag-header-row {
      border-bottom: 0px;
    }

    .ag-header {
      background-color: transparent;
      border: none;
    }

    .ag-header-cell {
      text-transform: uppercase;
      font-weight: normal;
      font-size: 11px;
      letter-spacing: 0.8px;
      padding-bottom: 5px;

      &::after {
        display: none;
      }
    }

    .ag-row {
      background-color: transparent;
      border-color: ${colors.grey3};

      &.ag-row-last {
        border-bottom: none;
      }

      .ag-cell {
        font-size: 13px;
        font-weight: normal;
        line-height: 24px;
        letter-spacing: 0.3px;
        color: ${colors.grey7};
      }
      &.highlighted-row {
        .ag-cell {
          font-weight: bold;
        }
      }
    }

    .ag-floating-top-viewport {
      border: none;
    }

    .ag-floating-top {
      border-color: ${colors.grey3};
    }

    .ag-row-pinned {
      border: none;

      &.ag-row-last {
        border: none;
      }

      .ag-cell {
        font-weight: bold;
      }
    }

    .ag-header-row-column {
      border-bottom: 1px solid ${colors.grey3};
    }
  }
`;

export const Container = styled.div`
  width: calc(100% + 12px);
  margin-top: 24px;
  margin-left: -12px;
`;
